import { Box, Button, Typography } from "@mui/material"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { jwtDecode } from "jwt-decode"
import { ContentContainer } from "./components/styles"
import IconBox from "../../components/IconBox"
import UIIcon from "../../components/UIIcon"
import { ROUTES_PATHS } from "../../utils/constants"
import { RootState } from "../../store/store"
import { IJwtPayload } from "../AuthOtpConfirmation/hooks/interface"

export const SuccessIdentification = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = useSelector((state: RootState) => state.auth.token)
  const payload = token
    ? jwtDecode<IJwtPayload & { Scope?: string }>(token)
    : undefined

  const handleClick = () => {
    if (
      !payload?.AdditionalData?.EncryptedCustomerData ||
      payload?.Scope === "identification"
    ) {
      navigate(`/${ROUTES_PATHS.topUpMbankAccountPayments}`)
    } else {
      searchParams.set(
        "redirectUrl",
        `/${ROUTES_PATHS.topUpMbankAccountPayments}`,
      )
  
      navigate({
        pathname: `/${ROUTES_PATHS.auth}`,
        search: searchParams.toString(),
      })
    }
  }

  return (
    <Box sx={ContentContainer}>
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        height="100%"
        pb="150px"
        gap={4}
      >
        <IconBox size="lg" color="yellow">
          <UIIcon iconName="checkYellow" size={80} />
        </IconBox>

        <Typography variant="h3" fontWeight={700} textAlign="center">
          Вы открыли кошелек <br /> в рублях
        </Typography>
      </Box>

      <Box mt="auto" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Button variant="contained" onClick={handleClick}>
          Готово
        </Button>
      </Box>
    </Box>
  )
}
